import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

import { responsive } from "../../utils/style";

import Gif from "../../assets/images/helpers/น้ำหวาน.GIF";

const Sweet = () => {
  return (
    <Container>
      <Image src={Gif} />
    </Container>
  );
};

const Container = styled.div`
  margin-top: 18px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Image = styled.img`
  width: 100%;
  max-width: 911px;
  margin-bottom: 80px;

  ${responsive.tablet(css`
    width: calc(100% - 16px);
    margin-bottom: 40px;
    margin-left: 8px;
    margin-right: 8px;
  `)}
`;

export default Sweet;
